import { useState, useEffect, useContext } from 'react';
import SliderPrincipal from "./sliderPrincipal";
import Sliders from "./sliders";
import GetCatProductos from "./getCatProductos";
import axios from 'axios';
import { Url } from './Url';

const Customer = () => {
    const [rubros, setRubros] = useState([])

    useEffect(() => {
        const getRubros = async () => {
            const formData = new FormData()
            
            try {
                const results = await axios({
                    url: Url + 'api/listRubros.php',
                    method: 'POST',
                    data: formData,
                })
                setRubros(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getRubros()
    }, [])

    return (
        <div className="w-full">
            <SliderPrincipal />
            <div className='w-full md:flex mx-auto mt-5'>
                { typeof rubros!=='undefined' && (
                    <Sliders data={rubros} tipo={2} />
                )}
            </div>
            <GetCatProductos />
        </div>
    )
}

export default Customer